export default (state) => ({
  ...state.userRoles.meta,
  total: Number(state.userRoles.meta.total),
  pages: Number(state.userRoles.meta.pages),
})
